"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const formik_1 = require("formik");
const react_1 = require("react");
const StructuralUnitCard_1 = tslib_1.__importDefault(require("src/modules/references/structuralUnitsUpgraded/views/card/StructuralUnitCard"));
const useOrdersStructuralUnits_1 = tslib_1.__importDefault(require("../hooks/useOrdersStructuralUnits"));
const OrdersStructuralUnits = ({ administrativeOrderId }) => {
    const [openModal, setOpenModal] = (0, react_1.useState)(false);
    const hook = (0, useOrdersStructuralUnits_1.default)({ administrativeOrderId: administrativeOrderId });
    const form = (0, formik_1.useFormik)({
        initialValues: hook.state.data,
        validateOnChange: false,
        enableReinitialize: true,
        onSubmit: async () => ({})
    });
    return ((0, jsx_runtime_1.jsx)(StructuralUnitCard_1.default, { form: form, hook: hook, openModal: openModal, setOpenModal: setOpenModal }));
};
exports.default = OrdersStructuralUnits;
